import { useState } from "react";
import InventoryMovementService from "../../../api/Inventory/InventoryMovementService";
import useLoading, { useLoad } from "../../../components/Common/useLoading";
import { getUsersById } from "../../../api/identity";

export default function useMoveHistory({ moveId }) {
    const [history, setHistory] = useState([]);
    const [isLoading, _] = useLoading({
        onLoad: async () => {
            const result = await InventoryMovementService.StateHistory({ moveId: moveId });

            const userIds = new Set(result.Value.map(h => h.userId))
            const usersResponse = (await getUsersById(Array.from(userIds))).data;
            const usersMap = new Map(usersResponse.map(user => [user.userId, user]));
            result.Value.forEach(history => {
                history.user = usersMap.get(history.userId)
            })
            setHistory(result.Value);
        }
    });


    return [history, isLoading];
}